import { ReactElement } from 'react';
import { Rating, Slider } from '@mantine/core';
import { YotpoReviewsData } from '../../../models/product.types';
import styles from '../ProductDisplayPage.module.scss';

type Props = {
  starDistribution: YotpoReviewsData['bottomline']['star_distribution'] | undefined;
  totalReviews: number;
};

export function RatingsBreakdown({
  starDistribution,
  totalReviews,
}: Props): ReactElement {
  return (
    <div className={styles.ratings_breakdown}>
      {(['5', '4', '3', '2', '1'] as const).map((star) => {
        const count = starDistribution?.[star] ?? 0;
        const percentage = totalReviews > 0 ? (count / totalReviews) * 100 : 0;
        return (
          <div key={star} className={styles.ratings_row}>
            {star}
            {' '}
            <Rating value={Number(star)} count={Number(1)} readOnly size="xs" />
            <Slider
              value={percentage}
              disabled
              className={styles.ratings_bar}
              size="md"
              thumbSize={0}
              label={null}
              styles={{
                root: { cursor: 'default' },
                bar: {
                  backgroundColor: percentage > 0 ? '#FAB005' : 'transparent',
                  opacity: 1,
                },
              }}
            />
            <span className={styles.ratings_row_count}>{count}</span>
          </div>
        );
      })}
    </div>
  );
}
